import { ApiSchemas } from '..'
import { client } from '../client'
import { wrapEndpoint } from '../wrap'

export default {
  async get(id: number) {
    return wrapEndpoint(() =>
      client.GET('/extension/{id}', {
        params: {
          path: {
            id,
          },
        },
      }),
    )
  },
  async getByName(name: string) {
    return wrapEndpoint(() =>
      client.GET('/extension/by-name/{name}', {
        params: {
          path: {
            name,
          },
        },
      }),
    )
  },
  async getSubscription(id: number) {
    return wrapEndpoint(() =>
      client.GET('/extension/{id}/subscription', {
        params: {
          path: {
            id,
          },
        },
      }),
    )
  },
  async list(options?: ApiSchemas['ListExtensionDto']) {
    return wrapEndpoint(() =>
      client.GET('/extension', {
        params: {
          query: options,
        },
      }),
    )
  },
  async subscribe(id: number, body: ApiSchemas['SubscribeToExtensionDto']) {
    return wrapEndpoint(() =>
      client.PATCH('/extension/{id}/subscribe', {
        params: {
          path: {
            id,
          },
        },
        body,
      }),
    )
  },
  async unsubscribe(id: number) {
    return wrapEndpoint(() =>
      client.PATCH('/extension/{id}/unsubscribe', {
        params: {
          path: {
            id,
          },
        },
      }),
    )
  },
}
